import { Dispatch } from "redux";
import {
    FormattedIdentityProviderDetails,
    IdentityProviderCategory,
    IdentityProviderClassification,
    IdentityProviderCompany,
    IdentityProviderLoa,
    IdentityProviderProtocol,
    IdentityProviderScheme
} from "@idw-types/data/identity-providers";
import { formatIdentityProviderDetails } from "@formatters/identity-providers";
import { updateIdentityProviderRequest } from "@requests/identity-provider";
import { setIdentityProviderDetails } from "@redux/actions/identity-provider-details-actions";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const updateIdentityProviderReduxRequest = (dispatch: Dispatch) => async (
    identityProviderDetails: FormattedIdentityProviderDetails,
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>,
    schemes: Array<IdentityProviderScheme>
): Promise<FormattedIdentityProviderDetails> => {
    const { data, error, body } = await updateIdentityProviderRequest(identityProviderDetails);
    if (data?.transferObject) {
        const formattedIdentityProviderDetails = formatIdentityProviderDetails(
            data.transferObject,
            categories,
            classifications,
            companies,
            loas,
            protocols,
            schemes
        );
        dispatch(setIdentityProviderDetails({
            ...formattedIdentityProviderDetails,
            permissions: {
                ...identityProviderDetails.permissions
            }
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.updateIdentityProvider.success.title,
            resources.requests.updateIdentityProvider.success.message
        );
        return {
            ...formattedIdentityProviderDetails,
            permissions: {
                ...identityProviderDetails.permissions
            }
        };
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateIdentityProvider.error.title,
            resources.requests.updateIdentityProvider.error.message,
            null,
            null,
            body
        );
    }

    return null;
};